import { useEffect, useState } from 'react';

/**
 * SPA-safe AdSense showAd logic for initial mount and route change.
 * Returns [showAd, setShowAd] for use in parent components.
 *
 * @param {string} pathname - The current route pathname (from useLocation().pathname)
 * @returns {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
 */
export function useSpaSafeShowAd(pathname: string): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [showAd, setShowAd] = useState(false);
  useEffect(() => {
    if (pathname) {
      setShowAd(false);   
      const timer = setTimeout(() => setShowAd(true), 300); // 300ms delay for route change
      return () => clearTimeout(timer);
    } 
  }, [pathname]);
  return [showAd, setShowAd];
}
